import { c as _c } from "react/compiler-runtime";
import { InputAttachmentsPreview } from '@newfront-insurance/nova-core';
import { useAttachments } from './attachments-provider';

/**
 * Component that displays the preview of uploaded attachments.
 * Should be rendered below the textarea but above the toolbar.
 * The toolbar is absolutely positioned, so this appears in normal flow above it.
 */
export function ChatAttachmentsPreview() {
  const $ = _c(3);
  const {
    attachments,
    setAttachments
  } = useAttachments();
  let t0;
  if ($[0] !== attachments || $[1] !== setAttachments) {
    t0 = <InputAttachmentsPreview attachments={attachments} setAttachments={setAttachments} />;
    $[0] = attachments;
    $[1] = setAttachments;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}